import { useNavigate, useParams } from "react-router";

/**
 * Hook que encapsula useNavigate preservando o prefixo /:state/:city
 * quando o portal está sendo acessado como sub-app (ex: /portalmunicipio/ba/pmibirataia/).
 * Em domínios standalone, navega normalmente sem prefixo.
 */
export function useRoutedNavigation() {
  const navigate = useNavigate();
  const routeParams = useParams<{ state?: string; city?: string }>();

  const buildPath = (path: string): string => {
    if (!routeParams.state || !routeParams.city) return path;
    if (path === '/') return `/${routeParams.state}/${routeParams.city}`;
    return `/${routeParams.state}/${routeParams.city}${path}`;
  };

  const navigateTo = (path: string) => navigate(buildPath(path));

  return { navigateTo, buildPath };
}
